import styled from 'styled-components'

export const Menu = styled.ul`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 48px;
  height: 20px;
  background: #ffffff;
  padding: 0 4px;
  list-style: none;

  &:after{
    content: '';
    position: absolute;
    left: 50%;
    top: 100%;
    width: 0;
    height: 0;
    transform: translateX(-50%);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #FFF;
  }
`

export const ButtonLanguage = styled.li`
  text-transform: uppercase;
  color: #2d5a64;
  font-weight: bold;
  font-size: 12px;
  transition: all .3s ease;

  &.active {
    color: #000;
  }
`